(() => {
  if (window.__sortDdLoaded) return;
  window.__sortDdLoaded = true;

  const closeAll = (except) => {
    document.querySelectorAll('.sort-dd').forEach((dd) => {
      if (dd === except) return;
      const trigger = dd.querySelector('[data-sort-trigger]');
      const panel = dd.querySelector('[data-sort-panel]');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
    });
  };

  document.addEventListener('click', (e) => {
    // Desktop sort-dd toggle
    const trigger = e.target.closest('[data-sort-trigger]');
    if (trigger) {
      e.preventDefault();
      const dd = trigger.closest('.sort-dd');
      const panel = dd.querySelector('[data-sort-panel]');
      const isOpen = !panel.hidden;
      closeAll(isOpen ? null : dd);
      panel.hidden = isOpen;
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      dd.classList.toggle('is-open', !isOpen);
      return;
    }
    // Mobile sort toggle
    const mobileTrigger = e.target.closest('[data-sort-mobile-trigger]');
    if (mobileTrigger) {
      e.preventDefault();
      e.stopPropagation();
      const wrap = mobileTrigger.closest('[data-sort-mobile-toggle]');
      const expanded = mobileTrigger.getAttribute('aria-expanded') === 'true';
      mobileTrigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      wrap.classList.toggle('is-open', !expanded);
      return;
    }
    if (!e.target.closest('.sort-dd')) closeAll(null);
  });

  // Desktop dropdown radio change
  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.sort-dd input[type="radio"]');
    if (radio) {
      const dd = radio.closest('.sort-dd');
      dd.querySelectorAll('.sort-dd__option').forEach((o) => o.classList.remove('is-active'));
      const optionEl = radio.closest('.sort-dd__option');
      if (optionEl) optionEl.classList.add('is-active');
      const panel = dd.querySelector('[data-sort-panel]');
      const trigger = dd.querySelector('[data-sort-trigger]');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
      return;
    }
    // Mobile sort radio change — update active row
    const mobileRadio = e.target.closest('.sort-mobile input[type="radio"]');
    if (mobileRadio) {
      const wrapper = mobileRadio.closest('.sort-mobile__options');
      if (wrapper) wrapper.querySelectorAll('.sort-mobile__option').forEach((o) => o.classList.remove('is-active'));
      const row = mobileRadio.closest('.sort-mobile__option');
      if (row) row.classList.add('is-active');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.sort-dd').forEach(dd => {
        const t = dd.querySelector('[data-sort-trigger]');
        const p = dd.querySelector('[data-sort-panel]');
        if (p) p.hidden = true;
        if (t) t.setAttribute('aria-expanded', 'false');
        dd.classList.remove('is-open');
      });
    }
  });
})();
